import { useContext } from 'react';
import UserContext from '@context/User/user-context';
import { BEGIN_STYLE_QUIZ_LINK } from '@constants/styleQuiz';

export default function useGetStartedCtaLink(): string {
  const { user } = useContext(UserContext);
  return user ? '/rooms/select-package' : BEGIN_STYLE_QUIZ_LINK;
}
